__turbopack_context__.v({
  "section-heading": "SectionHeading-module-scss-module__Q7wrSq__section-heading",
  "section-heading__eyebrow": "SectionHeading-module-scss-module__Q7wrSq__section-heading__eyebrow",
  "section-heading__headline": "SectionHeading-module-scss-module__Q7wrSq__section-heading__headline",
  "section-heading__headline--display": "SectionHeading-module-scss-module__Q7wrSq__section-heading__headline--display",
  "section-heading__subcopy": "SectionHeading-module-scss-module__Q7wrSq__section-heading__subcopy",
});
